import { SearchIcon } from "@heroicons/react/outline";
import { Link, useRouteMatch } from "react-router-dom";

const HeaderLeft = () => {
  let { path } = useRouteMatch();

  return (
    <div className="flex items-center">
      <div className="flex-grow">
        <img
          src="/images/LogoSec.png"
          alt=""
          className="lg:h-[2.5rem] lg:hidden"
        />
        <Link to={path}>
          <img
            src="/images/LogoSmall.png"
            alt=""
            className="lg:h-[2.5rem] hidden lg:block"
          />
        </Link>
      </div>
      <div className="hidden ml-10 lg:flex items-center space-x-2 bg-gray-100 py-2 px-3 rounded-sm border border-gray-300">
        <SearchIcon className="h-5 text-gray-500" />
        <input
          type="text"
          placeholder="search Memento"
          className="bg-transparent text-sm focus:outline-none outline-none"
        />
      </div>
    </div>
  );
};

export default HeaderLeft;
